import styled from 'styled-components';
import { SpaceProps, space } from 'styled-system';

// Components
import Button from '../../Button/Button';
import Box from '../../layoutComponents/Box/Box';

export type BaseStyleProps = SpaceProps;

interface IStyledTabProps extends BaseStyleProps {
  /**
   * Whether this Tab is active/
   */
  active: boolean;
  /**
   * Whether the Tabs component should stretch the full width of its container
   */
  fullWidth: boolean;
}

/**
 * Clickable Tab to open a Panel.
 */
export const StyledTab = styled(Button)<IStyledTabProps>`
  ${({ theme, active, fullWidth }) => `
    border-radius: 0;
    outline: none;
    margin: 0;
    border: none;
    border-bottom: 2px solid ${
      active ? `${theme.uptimeColors.mainTheme.primary}` : '#cccccc'
    };
    color: '#0A2543';
    text-align: left;
    padding: 9px;

    & > span {
      font-weight: 700;
      text-transform: capitalize;
      font-size: 1rem;
      color: ${active ? `${theme.uptimeColors.mainTheme.primary}` : '#58595B'};
    }

    ${fullWidth ? 'flex-grow: 1;' : ''}

    &:focus {
      color: '#0A2543';
      background: transparent;
      outline: none;
      outline-offset: -2px;
    }

    &:hover {
      background: '#E9F4FE';
      color: '#0A2543';
    }

    &:disabled {
      background: ${theme.uptimeColors.grayScales.white};
      border-bottom-color: '#cccccc';
      color: '#cccccc';
    }

    &:active, &:visited {
      background: ${theme.uptimeColors.grayScales.white};
    }
  `}
  ${space}
`;

export const PanelWrapper = styled(Box)<BaseStyleProps>`
  ${({ theme }) => `
    padding: ${theme.space[3]}px;
  `}
  width: 100%;
  ${space}
`;

export const TabsWrapper = styled.div<BaseStyleProps>`
  display: flex;
  flex-wrap: wrap;
  ${space}
`;

export default StyledTab;
